import { Fragment } from "react"
import { Button, Divider, CircularProgress } from "@mui/material"
import { ShoppingCart } from "@mui/icons-material"
import EventTicket from "../../../components/Cards/EventTicket"
import AlertDialog from "../../../components/Dialog/AlertDialog"
import useTicketListing from "./hooks/useTicketListing"
import { Body2, H4, H6, Body3, Body1 } from "../../../themes/typography"

function TicketListing({ eventData }) {

    const {
        handleProceed,
        loading,
        ticketData,
        totalTickets,
        selectedTickets,
        openModal,
        setOpenModal,
        modalVariant,
        goToEventPage
    } = useTicketListing(eventData);

    return (
        <Fragment>
            <div className="event-ticket-purchase-left-container">
                {ticketData?.length > 0 && ticketData.map((ticket) => (
                    <EventTicket
                        key={ticket?.ticket_id}
                        ticketId={ticket?.ticket_id}
                        name={ticket?.ticket_name}
                        description={ticket?.description}
                        ticketValidFor={ticket?.ticketValidFor}
                        saleStartDateTime={ticket?.ticket_sale_start}
                        saleEndDateTime={ticket?.ticket_sale_end}
                        price={ticket?.price}
                        saleStatus={ticket?.sale_status}
                        customerLimit={ticket?.customer_limit}
                        exceedStatus={ticket?.exceed_ticket_qty}
                        availableQty={ticket?.available_quantity}
                        isGroupTicket={ticket?.is_group_booking}
                        groupTicketAttendees={ticket?.attendees_per_ticket}
                    />
                ))}
            </div>

            <div className="event-ticket-purchase-right-container">
                {totalTickets === 0 && <EmptyCartUI />}

                {totalTickets > 0 && <TicketCart selectedTickets={selectedTickets} totalTickets={totalTickets} />}

                {totalTickets > 0 && (
                    <Button
                        variant="main"
                        fullWidth
                        onClick={handleProceed}
                        disabled={loading}
                    >
                        Proceed to Attendee Form {loading && (
                            <CircularProgress
                                size={20}
                                sx={{
                                    marginLeft: '0.75rem',
                                    color: 'var(--primary-color)'
                                }}
                            />
                        )}
                    </Button>
                )}
            </div>

            <AlertDialog
                dialogId="event-cancelled-dialog"
                dialogTitle={modalVariant === "eventCancelled"
                    ? "Oops! Event Cancelled"
                    : "Oops! Event Drafted"
                }
                open={openModal}
                onConfirm={goToEventPage}
                onCancel={() => setOpenModal(false)}
                primaryBtnName="Go to Homepage"
                shouldShowSecondaryBtn={false}
            >
                {modalVariant === "eventCancelled" && (
                    <Body1>
                        We're sorry, but this event has been cancelled and is no longer available for ticket purchases. Please visit our homepage to explore other events.
                    </Body1>
                )}

                {modalVariant === "eventDrafted" && (
                    <Body1>
                        We're sorry, but this event is currently in draft status and ticket purchases are temporarily unavailable. Wait for the event organizer to publish it again. Meanwhile, feel free to explore other events on our homepage.
                    </Body1>
                )}

            </AlertDialog>

        </Fragment>
    )
}

export default TicketListing

function EmptyCartUI() {
    return (
        <div className="empty-cart-ui">
            <div className="empty-cart-icon">
                <ShoppingCart sx={{ fontSize: "48px", color: "var(--tertiary-color)" }} />
            </div>
            <H4>Your cart is empty</H4>
            <Body2 fontWeight={300}>
                Looks like you haven’t added anything yet.
            </Body2>
        </div>
    )
}

const data = [
    {
        ticketName: 'VIP Ticket',
        quantity: 2
    },
    {
        ticketName: 'Regular Ticket',
        quantity: 5
    }
]

export function TicketCart({
    selectedTickets = data,
    totalTickets = 0
}) {
    return (
        <div className="event-tickets-add-to-cart">
            <H6 color="var(--secondary-color)">Cart Details</H6>

            <div className="event-tickets-cart-summary">
                <div className="event-ticket-name-and-qty-label-container">
                    <div>
                        <Body2>
                            Tickets
                        </Body2>
                    </div>

                    <div>
                        <Body2>
                            Quantity
                        </Body2>
                    </div>
                </div>

                <Divider sx={{ borderColor: 'var(--divider-color)', alignSelf: 'stretch' }} />

                <div className="event-tickets-listing-container">
                    {selectedTickets?.map((ticket, index) => {
                        return (
                            <div className="tickets-cart-listing-container" key={index}>
                                <div className="added-ticket-name-container">
                                    <Body3 fontWeight={500}>{ticket.name}</Body3>
                                </div>

                                <div className="added-ticket-quantity-container">
                                    <Body3 color="var(--secondary-color)" fontWeight={500}>
                                        {ticket.quantity}
                                    </Body3>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <Divider sx={{ borderColor: 'var(--divider-color)', alignSelf: 'stretch' }} />

            <div className="event-tickets-cart-total-qty-container">
                <H6>Total Tickets :</H6>
                <H6 color="var(--secondary-color)">{totalTickets}</H6>
            </div>
        </div>
    );
}